export { default } from "./NewsMediaCard";
